import classNames from 'classnames';
import React, { FC } from 'react';
import {
  Adult,
  AllWD,
  Automatic,
  Calendar,
  Chevron,
  Child,
  CircleTick,
  Cross,
  ElectricStove,
  Error,
  FourWD,
  Fridge,
  FridgeFreezer,
  GasStove,
  Hamburger,
  Information,
  Manual,
  Minus,
  Pin,
  Plus,
  PortableStove,
  ReverseDirection,
  Search,
  Shower,
  Tick,
  Toilet,
  TwoWD,
  Warning,
  RecatngleRedError,
  CircleGreenCheck,
} from './Icons';

import { CosmosComponent } from '../../../types';
import { IconTypeDeprecated } from './types';

import styles from './IconDeprecated.module.css';

type Icons = {
  [key: string]: JSX.Element;
};

// TODO: to Enum if makes sense
export interface IconDeprecatedProps extends CosmosComponent {
  name: IconTypeDeprecated;
  viewBox?: string;
  style?: any;
}

export const icons: Icons = {
  calendar: Calendar,
  pin: Pin,
  chevron: Chevron,
  'reverse-direction': ReverseDirection,
  search: Search,
  cross: Cross,
  adult: Adult,
  child: Child,
  'fridge-freezer': FridgeFreezer,
  fridge: Fridge,
  'gas-stove': GasStove,
  'electric-stove': ElectricStove,
  'portable-stove': PortableStove,
  manual: Manual,
  automatic: Automatic,
  shower: Shower,
  toilet: Toilet,
  plus: Plus,
  minus: Minus,
  hamburger: Hamburger,
  fourWD: FourWD,
  twoWD: TwoWD,
  allWD: AllWD,
  tick: Tick,
  circleTick: CircleTick,
  information: Information,
  warning: Warning,
  error: Error,
  recatngleRedError: RecatngleRedError,
  circleGreenCheck: CircleGreenCheck,
};

const getViewBox = (iconName: string) => {
  switch (iconName) {
    case 'cross':
      return '0 0 16 16';
    case 'adult':
    case 'child':
    case 'fridge-freezer':
    case 'fridge':
    case 'gas-stove':
    case 'electric-stove':
    case 'portable-stove':
    case 'manual':
    case 'automatic':
    case 'shower':
    case 'toilet':
    case 'plus':
    case 'minus':
    case 'hamburger':
    case 'fourWD':
    case 'twoWD':
    case 'tick':
    case 'circleTick':
    case 'information':
      return '0 0 40 40';
    case 'allWD':
      return '0 0 42 40';
    default:
      return '0 0 20 20';
    case 'warning':
      return '0 0 512 512';
    case 'error':
      return '0 0 512 512';
    case 'recatngleRedError':
    case 'circleGreenCheck':
      return '0 0 24 24';
  }
};

export const IconDeprecated: FC<IconDeprecatedProps> = ({
  className,
  isInverted = false,
  name,
  viewBox: customViewBox,
  testId,
}) => {
  const viewBox = customViewBox || getViewBox(name);

  return (
    <span className={className} data-test-id={testId}>
      <svg
        className={classNames(className, styles.Icon, {
          [styles.inverted]: isInverted,
        })}
        viewBox={viewBox}
      >
        {icons[name]}
      </svg>
    </span>
  );
};
